import { render, staticRenderFns } from "./html-text-widget.vue?vue&type=template&id=54e9e5be&scoped=true&"
import script from "./html-text-widget.vue?vue&type=script&lang=js&"
export * from "./html-text-widget.vue?vue&type=script&lang=js&"
import style0 from "./html-text-widget.vue?vue&type=style&index=0&id=54e9e5be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e9e5be",
  null
  
)

export default component.exports